﻿import $ from 'jquery';
import Modal from "../modal";
import RequestVerificationToken from "../../utilities/requestverificationtoken";
import { IRemoteOptions } from "./remote";
import { Confirmation, IConfirmationOptions } from "../confirmation";

declare global {
  interface JQuery {
    executeFunctionByName: (functionName: string, context: any, ...args: any[]) => any;
  }
}


export class Ajax {

  static execute(options: IRemoteOptions): void;
  static execute($element: JQuery, options: IRemoteOptions): void;
  static execute(arg1, arg2?) {
    let options = arg2 || arg1;

    if (arg2)
      options.$element = arg1;

    new AjaxCall(options).execute();
  }
}

class AjaxCall {
  private options: IRemoteOptions;
  private createXhr: any;

  private get $element(): JQuery { return this.options.$element; }

  constructor(options: IRemoteOptions) {
    this.options = options;
  }

  execute() {
    if (!this.options.url || this.options.url.indexOf('javascript') == 0)
      return;

    if (this.options.beforeRemote)
      this.options.beforeRemote();

    this.options.data = this.options.data || {};
    if (this.options.type == 'post')
      this.addAntiForgeryToken();

    if (this.$element && this.$element.data('confirm'))
      this.confirm();
    else
      this.ajax();
  }

  addAntiForgeryToken(): void {
    if (typeof (this.options.data) != "object")
      return;
    if (this.options.data['__RequestVerificationToken'])
      return;
    var token = new RequestVerificationToken();
    this.options.data[token.key] = token.value;
  }

  confirm() {
    let confirm = <IConfirmationOptions>this.$element.data('confirm');
    confirm.callback = () => this.ajax();

    if (confirm.showOnTarget) {
      this.$element.data('rustig.lastoffset', this.$element.offset());
      confirm.$target = this.$element;
    }

    Confirmation.show(confirm);
  }

  ajax() {
    if (!this.options.allowMultipleAjaxCalls && this.$element && this.$element.data('is-ajaxing'))
      return;

    let offset;
    if (this.$element) {
      offset = this.$element.offset();
      this.$element.data('is-ajaxing', true)
                   .trigger('ajaxstart.rustig.remote');
    }

    $.ajax({
      url: this.options.url,
      type: this.options.type || 'get',
      data: this.options.data,
      cache: false,
      xhr: this.createXhr,
      contentType: this.options.contentType,
      processData: this.options.processData,
      traditional: this.options.traditional,
      dataFilter: (data) => {
        if (this.options.dataFilter)
          return this.options.dataFilter(data, this.options.state);
        else
          return data;
      },
      async: this.options.async,
      success: (data, textStatus, jqXHR) => {
        if (this.options.success)
          return this.options.success(data, textStatus, jqXHR);

        if (!data || !data.Data)
          return;

        for (var i = 0; i < data.Data.length; i++) {
          var current = data.Data[i]
          var callback = current ? current.RustigRemoteJsCallback : null;
          if (!callback)
            return;

          var callbackArgs = current.Data;
          if (callbackArgs) {
            callbackArgs.remoteOptions = this.options;
            if (this.$element) {
              callbackArgs.$remoteTarget = this.$element.data('rustig.lastoffset', offset);
            }
          }

          $.fn.executeFunctionByName(callback, window, callbackArgs, textStatus, jqXHR);
        }
      },
      error: (jqXHR, textStatus, errorThrown) => {
        if (this.$element)
          this.$element.trigger('ajaxerror.rustig.remote', this.options.state);

        var errorHandled = false;
        if (this.options.error)
          errorHandled = this.options.error(jqXHR, textStatus, errorThrown);

        if (!errorHandled && !window.isWindowUnloading) {
          if (jqXHR.status == 0)
            Modal.openDisconnectModal();
          else
            Modal.openErrorModal(jqXHR.responseText);
        }
      },
      complete: () => {
        if (this.$element) {
          this.$element.data('is-ajaxing', false)
            .trigger('ajaxcomplete.rustig.remote', this.options.state)
            .trigger('remote', this.options.state);
        }
      }
    });
  }
}

$.fn.executeFunctionByName = function (functionName: string, context: any, ...args: any[]): any {
  var throwCallbackError = function (functionName) {
    throw "Callback function was not found: " + functionName;
  };

  var namespaces = functionName.split(".");
  var func = namespaces.pop();
  for (var i = 0; i < namespaces.length; i++) {
    context = context[namespaces[i]];
    if (!context) throwCallbackError(functionName);
  }
  var lastFunc = context[func];
  if (!lastFunc) throwCallbackError(functionName);

  return lastFunc.call(this, args[0]);
}

export default Ajax;